import React, { Fragment, useEffect, useState } from 'react';
import Loader from '../common/loaderapp';
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SITE_BASE_URL = ('https://lprefacciones.mx').replace(/\/+$/, '');
const SITE_IMAGE_ENDPOINT = `${SITE_BASE_URL}/imagen`;
const SITE_DEFAULT_PRODUCT_IMAGE = `${SITE_BASE_URL}/img/default-image.png`;
const MONTHS_SHORT_ES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
const MONTHS_SHORT_EN = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

const formatFechaRegistro = (fecha) => {
    if (!fecha) return '-';
    const trimmed = String(fecha).trim();
    const regex = /^([A-Za-z]{3,})\s+(\d{1,2})\s+(\d{4})/;
    const match = trimmed.match(regex);
    if (match) {
        const [, monthText, dayText, yearText] = match;
        const monthIndex = MONTHS_SHORT_EN.indexOf(monthText.slice(0, 3).toLowerCase());
        const month = monthIndex >= 0 ? MONTHS_SHORT_ES[monthIndex] : monthText;
        const day = dayText.padStart(2, '0');
        return `${day} ${month} ${yearText}`.trim();
    }
    const parsedDate = new Date(trimmed);
    if (Number.isNaN(parsedDate.getTime())) return trimmed;
    const day = parsedDate.getDate().toString().padStart(2, '0');
    const month = MONTHS_SHORT_ES[parsedDate.getMonth()] || '';
    const year = parsedDate.getFullYear();
    return `${day} ${month} ${year}`.trim();
};

const getSiteProductImageSrc = (sku) => {
    const cleanSku = String(sku || '').trim();
    if (!cleanSku) return SITE_DEFAULT_PRODUCT_IMAGE;
    return `${SITE_IMAGE_ENDPOINT}?img=${encodeURIComponent(`${cleanSku}/0.png`)}`;
};

const Detalle = ({pag_actualizar,setPag_actualizar}) => {

    const [load, setLoad] = useState(false);
    const [datos, setDatos] = useState({});
	const [preview_img, setPreview_img] = useState({});
	const [look_archivos, setLook_archivos] = useState(false);

    useEffect(() => {
        if(pag_actualizar.SITIO != 'COTIZADOR'){
            fetch('/p_buzon', {
                headers: {'Content-Type': 'application/json'},
                method:'POST',
                body: JSON.stringify({ID:pag_actualizar.ID})
            })
            .then(res => res.json())
            .then(res =>{
                //console.log(res);
                setDatos(res);
                setLoad(true)
            })
            .catch(err => console.log('Error: '+err))
        }
        else{
            fetch('/p_buzon', {
                headers: {'Content-Type': 'application/json'},
                method:'PUT',
                body: JSON.stringify({ID:pag_actualizar.ID})
            })
            .then(res => res.json())
            .then(res =>{
                console.log(res);
                setDatos(res);

				var preview_img_temp = {}
				res[2].map(x=>{
					fetch('/imagen_cotizacion', {
						headers: {'Content-Type': 'application/json'},
						method:'POST',
						body: JSON.stringify({FOLIO:x.FOLIO,ID:x.ID})
					})
					.then(res => res.json())
					.then(res=>{
						preview_img_temp[x.ID] = res
						//preview_img_temp.push({ID:x.ID,lista:res})
					})
				})
				setPreview_img(preview_img_temp)
				setLoad(true)
            })
        }
    }, []);

	const descargarArchivos=()=>{
		setLook_archivos(true)
		var nombre_archivo

		fetch('/p_archivo_vacante_f', {
            headers:{'Content-Type': 'application/json'},
			method:'POST',
			body: JSON.stringify({ID:pag_actualizar.ID})
		})
        .then( res => res.json() )
        .then( res => {
            nombre_archivo=res.filename

			for (let index = 0; index < nombre_archivo.length; index++) {
				let numero=index
				fetch('/p_archivo_vacante', {
        		    headers:{'Content-Type': 'application/json'},
					method:'POST',
					body: JSON.stringify({ID:pag_actualizar.ID,pos:numero})
				})
        		.then( res => res.blob() )
        		.then( blob => {
        		    let file = window.URL.createObjectURL(blob);
        		    let a = document.createElement('a');
        		    a.href = file;
        		    a.download = `${nombre_archivo[numero]}`;
        		    document.body.appendChild(a);
        		    a.click();    
        		    a.remove(); 
					setLook_archivos(false)
        		});
				
			}
        });
	}

	const descargarArchivosCoti=(folio,id,nombre)=>{
		setLook_archivos(true)
		
		fetch('/p_archivo_cotizacion', {
            headers:{'Content-Type': 'application/json'},
			method:'POST',
			body: JSON.stringify({ID:id,FOLIO:folio,NOMBRE:nombre})
		})
        .then( res => res.blob() )
        .then( blob => {
            let file = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = file;
            a.download = `${nombre}`;
            document.body.appendChild(a);
            a.click();    	
            a.remove(); 
			setLook_archivos(false)
        });
	}

    return (
        <div className="container-fluid">
            {
				load ?
				<Fragment>
					<div className="card">
						<div className="card-header">
							<div className="row">
								<h5>Cotización<br></br> <span className="text-muted text-capitalize font-weight-light">Fecha registro: {formatFechaRegistro(pag_actualizar.DIA)}</span></h5>
							</div>
						</div>
						<div className="card-body">
								<button className="btn btn-outline-light-2x txt-dark" onClick={()=> setPag_actualizar([])}>
                                    <i className="icofont icofont-arrow-left"/>Regresar
                                </button>							
						  	<div className="row">
                                {
                                    pag_actualizar.SITIO != 'COTIZADOR' ?
                                    <Fragment>
                                        <div className="col-md-12">
								          	<div className="date-picker">
								        	  	<h2 className="text-center font-weight-bold mb-4">Datos personales</h2>
								        		<form className="theme-form ml-5">
                                        
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Nombres(s):</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.NOMBRE !='' ? datos.NOMBRE : '-' }</label>
								        		  	</div>
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Apellidos:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.APELLIDOS !='' ? datos.APELLIDOS : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Correo electrónico:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.EMAIL !='' ? datos.EMAIL : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Teléfono:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.TELEFONO !='' ? datos.TELEFONO : '-'}</label>
								        		  	</div>
                                                    <div className="row d-flex justify-content-around">
														<button type="button" className="col-sm-3 btn btn-outline-primary pl-2 pr-2" onClick={descargarArchivos} disabled={look_archivos}>Descargar Archivo ({datos.TOTAL_ARCHIVOS})</button>
										  			</div>
								        		</form>
								          	</div>
								        </div>
                                        <div className="col-md-12">
								        <hr/>
								          	<div className="date-picker">
								        	  	<h2 className="text-center font-weight-bold mb-4">Datos de la bolsa de trabajo</h2>
								        		<form className="theme-form ml-5">
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Puesto:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.PUESTO !='' ? datos.PUESTO : '-'}</label>
								        		  	</div>
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Descripción:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.DESCRIPCION !='' ? datos.DESCRIPCION : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Estado:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.ESTADO !='' ? datos.ESTADO : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Ciudad:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.CIUDAD !='' ? datos.CIUDAD : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Escolaridad:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.ESCOLARIDAD !='' ? datos.ESCOLARIDAD : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Edad:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.EDAD !='' ? datos.EDAD : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Género:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.GENERO !='' ? datos.GENERO : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Cualidades:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.CUALIDADES !='' ? datos.CUALIDADES : '-'}</label>
								        		  	</div>
                                                      <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Requerimientos:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.REQUERIMIENTOS !='' ? datos.REQUERIMIENTOS : '-'}</label>
								        		  	</div>
                                                      <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Actividades a realizar:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.ACTIVIDADES_A_REALIZAR !='' ? datos.ACTIVIDADES_A_REALIZAR : '-'}</label>
								        		  	</div>
                                                      <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Sueldos y prestaciones:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos.SUELDOS_Y_PRESTACIONES !='' ? datos.SUELDOS_Y_PRESTACIONES : '-'}</label>
								        		  	</div>
								        		</form>
								          	</div>
								        </div>
                                    </Fragment> 
                                    :
                                    <Fragment>
                                        <div className="col-md-12">
								          	<div className="date-picker row d-flex justify-content-center">
								        	  	<h2 className="text-center font-weight-bold mb-4 col-12">Datos de la solicitud</h2>
								        		<form className="theme-form ml-5 col-md-5">
                                                    <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Folio:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].FOLIO !='' ? datos[0][0].FOLIO : '-' }</label>
								        		  	</div>
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Nombres(s):</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].NOMBRE !='' ? datos[0][0].NOMBRE : '-' }</label>
								        		  	</div>
								        		  	<div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Apellidos:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].APELLIDOS !='' ? datos[0][0].APELLIDOS : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Correo electrónico:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].EMAIL !='' ? datos[0][0].EMAIL : '-'}</label>
								        		  	</div>
								        			  <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Teléfono:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].WHATSAPP !='' ? datos[0][0].WHATSAPP : '-'}</label>
								        		  	</div>
                                                      <div className="form-group form-row">
								        				<label className="col-sm-3 col-form-label text-left font-weight-bold">Empresa:</label>
								        				<label className="col-sm-9 col-form-label text-left">{datos[0][0].EMPRESA !='' ? datos[0][0].EMPRESA : '-'}</label>
								        		  	</div>
								        		</form>
								        		<form className="theme-form ml-5 col-md-5">
                                                    {
                                                        datos[0][0].TIPO_RECIBIR != 'domicilio' ?
                                                        <Fragment>
                                                            <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Recibir:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">En sucursal</label>
								        		  	        </div>
                                                            <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Estado:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].S_ESTADO !='' ? datos[0][0].S_ESTADO : '-' }</label>
								        		  	        </div>
								        		  	        <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Ciudad:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].S_CIUDAD !='' ? datos[0][0].S_CIUDAD : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Sucursal:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].S_SUCURSAL !='' ? datos[0][0].S_SUCURSAL : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Dirección sucursal:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].S_DOMICILIO !='' ? datos[0][0].S_DOMICILIO : '-'}</label>
								        		  	        </div>
                                                        </Fragment>
                                                        :
                                                        <Fragment>
                                                            <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Recibir:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">En domicilio</label>
								        		  	        </div>
                                                            <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Calle:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_CALLE !='' ? datos[0][0].D_CALLE : '-' }</label>
								        		  	        </div>
								        		  	        <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Núm exterior:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_NUMEXTERIOR !='' ? datos[0][0].D_NUMEXTERIOR : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Núm interior:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_NUMINTERIOR !='' ? datos[0][0].D_NUMINTERIOR : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Código postal:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_CODIGOPOSTAL !='' ? datos[0][0].D_CODIGOPOSTAL : '-'}</label>
								        		  	        </div>
                                                              <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Estado:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_ESTADO !='' ? datos[0][0].D_ESTADO : '-' }</label>
								        		  	        </div>
								        		  	        <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Ciudad:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_CIUDAD !='' ? datos[0][0].D_CIUDAD : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Colonia:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_COLONIA !='' ? datos[0][0].D_COLONIA : '-'}</label>
								        		  	        </div>
								        			          <div className="form-group form-row">
								        			        	<label className="col-sm-3 col-form-label text-left font-weight-bold">Referencias:</label>
								        			        	<label className="col-sm-9 col-form-label text-left">{datos[0][0].D_REFERENCIAS !='' ? datos[0][0].D_REFERENCIAS : '-'}</label>
								        		  	        </div>
                                                        </Fragment>
                                                    }
								        		</form>
								          	</div>
								        </div>

										{
											datos[1].length != 0 &&
											<div className="col-md-12">
								        	<hr/>
								        	  	<div className="date-picker">
								        		  	<h2 className="text-center font-weight-bold mb-4">Productos cotizados</h2>
														{
															datos[1].map(x=><div className="row product-page-main mb-0">
                        									    <div className="col-xl-4 d-flex justify-content-center">
                        									            <img
                        									                src={getSiteProductImageSrc(x.SKU)}
                        									                alt={x.SKU || 'Producto cotizado'}
                        									                width="222"
                        									                height="222"
                        									                onError={event => {
                        									                    event.currentTarget.onerror = null;
                        									                    event.currentTarget.src = SITE_DEFAULT_PRODUCT_IMAGE;
                        									                }}
                        									            />
                        									    </div>
                        									    <div className="col-xl-8">
                        									        <div className="product-page-details">
                        									            <h5><strong>{x.name}</strong></h5>
                        									        </div>
                        									        <hr />
                        									        <p>{x.description}</p>
																	<p><strong>SKU:</strong> {x.SKU}</p>
																	<p><strong>Cantidad:</strong> {x.CANTIDAD}</p>
																	<p><strong>Unidad:</strong> {x.UNIDAD || x.unidad || '-'}</p>
                        									    </div>
                        									</div>)
														}
								        	  	</div>
								        	</div>
										}

										{
											datos[2].length != 0 &&
											<Fragment>
												<div className="col-md-12">
								        		<hr/>
								        		  	<div className="date-picker">
								        			  	<h2 className="text-center font-weight-bold mb-4">Cotización especial</h2>
															{
																datos[2].map(x=><div className="row product-page-main mb-0">
                        										    <div className="col-xl-12">
                        										        <div className="product-page-details">
                        										            <h5><strong>{x.PRODUCTO}</strong></h5>
                        										        </div>
                        										        <hr />
                        										        <p><strong>Marca:</strong> {x.DETALLES}</p>
																		<p><strong>Cantidad:</strong> {x.CANTIDAD}</p>
															
																		{x.TOTAL_ARCHIVOS == 0 && <Fragment><br/></Fragment>}
                        										    </div>
																	{
																		x.TOTAL_ARCHIVOS != 0 && 
																		<div className="my-gallery card-body row d-flex justify-content-center">
																			{
																				preview_img[`${x.ID}`] != undefined && preview_img[`${x.ID}`].map(y=><figure className="col-xl-3 col-sm-6">
                                    											    <img
                                            src={`/imagen_coti?FOLIO=${x.FOLIO}&ID=${x.ID}&img=${y}`}
																						height="200"
                                    											        alt="Gallery"
                                    											        className="img-thumbnail"
                                    											        onClick={() =>{}
                                    											            //this.setState({ photoIndex: 0, isOpen: true })
                                    											        }
                                    											    />
                                    											</figure>)
																			}
																		</div>
																	}
																	
                        										</div>)
															}
								        		  	</div>
								        		</div>
											</Fragment>
											
										}

										{
											datos[3].length != 0 &&
											<Fragment>
												<div className="col-md-12">
								        		<hr/>
								        		  	<div className="date-picker">
								        			  	<h2 className="text-center font-weight-bold">Archivos subidos</h2>
															{
																datos[3].map((x,i)=><div className="row mb-2">
                        										    <div className="col-xl-12 d-inline-flex justify-content-between">
																		<p><strong>{i+1}.- {x.NOMBRE}</strong></p>
																		<button type="button" className="col-sm-3 btn btn-outline-primary pl-2 pr-2" onClick={()=>{descargarArchivosCoti(x.FOLIO,x.ID,x.NOMBRE)}}>Descargar Archivo</button>
                        										    </div>																	
                        										</div>)
															}
								        		  	</div>
								        		</div>
											</Fragment>
										}
										
                                    </Fragment>
                                }
						  	</div>
						</div>
		  			</div>
				</Fragment>
				: <Loader/>
			}
        </div>
    );
}
 
export default Detalle;
